import { Interval, DateTime, Info } from "luxon";

const localeData = (options, i18n) => {
  let default_locale = {
    direction: "ltr",
    applyLabel: i18n.t("DateTimeRangePicker.apply"),
    cancelLabel: i18n.t("DateTimeRangePicker.cancel"),
    resetLabel: i18n.t("DateTimeRangePicker.reset"),
    customRangeLabel: i18n.t("DateTimeRangePicker.templates.custom"),
    daysOfWeek: Info.weekdays("short"),
    firstDay: 1,
    ranges: i18n.t("DateTimeRangePicker.templates"),
    interval: i18n.t("DateTimeRangePicker.interval")
  };
  return { ...default_locale, ...options };
};

const DefaultRanges = {
  today: () =>
    Interval.fromDateTimes(
      DateTime.local().startOf("day"),
      DateTime.local().endOf("day")
    ),
  yestarday: () =>
    Interval.fromDateTimes(
      DateTime.local()
        .minus({ days: 1 })
        .startOf("day"),
      DateTime.local()
        .minus({ days: 1 })
        .endOf("day")
    ),
  last7Days: () =>
    Interval.fromDateTimes(
      DateTime.local()
        .startOf("day")
        .minus({ days: 7 }),
      DateTime.local().endOf("day")
    ),
  currentWeek: () =>
    Interval.fromDateTimes(
      DateTime.local().startOf("week"),
      DateTime.local().endOf("week")
    ),
  lastWeek: () =>
    Interval.fromDateTimes(
      DateTime.local()
        .minus({ weeks: 1 })
        .startOf("week"),
      DateTime.local()
        .minus({ weeks: 1 })
        .endOf("week")
    ),
  currentMonth: () =>
    Interval.fromDateTimes(
      DateTime.local().startOf("month"),
      DateTime.local().endOf("month")
    ),
  lastMonth: () =>
    Interval.fromDateTimes(
      DateTime.local()
        .minus({ months: 1 })
        .startOf("month"),
      DateTime.local()
        .minus({ months: 1 })
        .endOf("month")
    )
};
export { localeData, DefaultRanges };
